<template>
  <div>
    <section>
      <div class="form-inline flex-row">
        <label for="active">Projects:</label>
        <div>
          <model-select
            :options="projectOptions"
            v-model="editProjectId"
            placeholder="Project"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row" v-if="editProjectId">
        <label for="active">Roles:</label>
        <div>
          <model-select
            :options="projectToRoles.get(editProjectId)"
            v-model="editRoleId"
            placeholder="Role"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >Add</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  props: ["submitLoading", "projectOptions", "projectToRoles", "addType"],
  data() {
    return {
      editProjectId: null,
      editRoleId: null,
    };
  },
  components: {
    spinnerButton,
    ModelSelect,
  },
  watch: {
    projectOptions: function () {
      this.initData();
    },
    projectToRoles: function () {
      this.initData();
    },
  },
  mounted: function () {
    this.initData();
  },
  methods: {
    initData: function () {
      this.submitLoading = false;
      this.editProjectId = null;
      this.editRoleId = null;
    },
    buttonClick: function () {
      const data = {
        editProjectId: this.editProjectId,
        editRoleId: this.editRoleId,
      };
      this.$emit("buttonClick", data);
    },
  },
};
</script>
